import styled, { css } from 'styled-components';
import { always, cond, propEq } from 'ramda';

import { media } from '@theme/media';
import { SIMPLE_LEGAL_BLOCK_TITLE } from '@components/blocks';
import { COLORS } from '@theme/colors';

import { linkStyles, legalPageFontStyles } from '../blocks.styles';

export const legalPageRichTextStyles = css`
  p {
    margin: 14px 0;

    ${media.mobile} {
      margin: 11px 0;
    }
  }

  a {
    ${linkStyles};
  }

  ul {
    margin: 0 0 0 25px;
    padding: 0 0 0 16px;
    list-style: none;
    line-height: 1.5em;

    & > li {
      position: relative;

      &:before {
        content: '\\2013';
        position: absolute;
        left: -16px;
        top: 0;
      }
    }
  }
`;

export const Container = styled.div`
  ${legalPageFontStyles};
`;

interface TitleProps {
  displayOption: SIMPLE_LEGAL_BLOCK_TITLE;
}

const titleBlankLineStyles = css`
  margin: 30px 0;
`;

const titleBottomLineStyles = css`
  border-bottom: 1px solid ${COLORS.BLACK};
  margin-bottom: 34px;
`;

const titleTopLineStyles = css`
  border-top: 1px solid ${COLORS.BLACK};
  margin-bottom: 17px;
  margin-top: 60px;

  ${media.mobile} {
    margin-bottom: 17px;
    margin-top: 30px;
  }
`;

// @ts-ignore
const getTitleLineStyles: ({ displayOption }: TitleProps) => string = cond([
  [propEq('displayOption', SIMPLE_LEGAL_BLOCK_TITLE.TOP), always(titleTopLineStyles)],
  [propEq('displayOption', SIMPLE_LEGAL_BLOCK_TITLE.BOTTOM), always(titleBottomLineStyles)],
  [propEq('displayOption', SIMPLE_LEGAL_BLOCK_TITLE.BLANK), always(titleBlankLineStyles)],
]);

export const Title = styled.div<TitleProps>`
  ${legalPageFontStyles};
  display: block;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  padding-top: 9px;
  padding-bottom: 6px;
  ${getTitleLineStyles};
`;

export const Content = styled.div`
  ${legalPageRichTextStyles};
`;
